import { Condition, VraagAntwoordId } from '../vragenboom/condition';

export class ConditionMapper {
  public static map(vraagId: string, linkt_naar: string): Condition[] {
    if (!linkt_naar)
      return [];

    if (!linkt_naar.startsWith('CONDITIE='))
      return [new Condition(null, linkt_naar)];

    const condition = linkt_naar.substring(9);
    const matches = condition.match(/\[[A-Z|a-z:_-\d{}=;\.]*\]/g);
    if (!matches || matches.length === 0)
      return [];

    const conditions: Condition[] = [];
    for (const match of matches) {
      // Remove [] at begin and end
      const matchValue = match.substring(1, match.length - 1);
      const conditionItems = matchValue.split(';');

      if (conditionItems.length === 1) {
        conditions.push(new Condition(null, conditionItems[0]));
        continue;
      }

      const answers = conditionItems[0]
        .split('|')
        .map((x): VraagAntwoordId => {
          const split = x.split(':');
          if (split.length == 1)
            return { vraagId: vraagId, antwoordId: x };
          else
            return { vraagId: split[0], antwoordId: split[1] };
        });

      conditions.push(new Condition(answers, conditionItems[1]));
    }

    return conditions;
  }
}
